import { useState } from "react";
import Layout from "../../components/Layout";
import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import ProfileInfo from "./tabs/ProfileInfo";
import ChangePassword from "./tabs/ChangePassword";
import Notifications from "./tabs/Notifications";
import Sessions from "./tabs/Sessions";
import "../Settings/Settings.css";

const tabs = [
  { id: "profile",       label: "Profile Information",     icon: "person" },
  { id: "password",      label: "Change Password",          icon: "lock" },
  { id: "notifications", label: "Notification Preferences", icon: "notifications" },
  { id: "sessions",      label: "Session Management",       icon: "desktop_windows" },
];

const Settings = () => {
  const [activeTab, setActiveTab] = useState("profile");

  return (
    <Layout>
      <div className="profile-page">
        <div className="profile-page-header">
          <Breadcrumbs />
          <h2>Account Settings</h2>
          <p>Manage your personal information and account preferences.</p>
        </div>

        <div className="profile-layout">
          <div className="profile-nav">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                className={`profile-nav-item ${activeTab === tab.id ? "active" : ""}`}
                onClick={() => setActiveTab(tab.id)}
              >
                <span className="material-symbols-outlined">{tab.icon}</span>
                {tab.label}
              </button>
            ))}
          </div>

          <div className="profile-content">
            {activeTab === "profile"       && <ProfileInfo />}
            {activeTab === "password"      && <ChangePassword />}
            {activeTab === "notifications" && <Notifications />}
            {activeTab === "sessions"      && <Sessions />}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Settings;